<template>
    <div>
        <el-form :inline="true" :model="query" class="query-form" size="mini" @submit.native.prevent="onSubmit">

            <el-form-item label="类型：" class="query-form-item" prop="type">
                <el-select v-model="query.type" placeholder="请选择类型" size="mini">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="义乌" value="义乌"></el-option>
                    <el-option label="盈和" value="盈和"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="FBA入仓号：" class="query-form-item">
                <el-input v-model="query.warehouse_number" placeholder="请输入FBA入仓号"></el-input>
            </el-form-item>
            <el-form-item label="Reference ID：" class="query-form-item">
                <el-input v-model="query.reference_id" placeholder="请输入Reference ID"></el-input>
            </el-form-item>

            <el-form-item label="编号：" class="query-form-item">
                <el-input v-model="query.number" placeholder="请输入编号"></el-input>
            </el-form-item>

            <el-form-item>
                <el-button icon="el-icon-refresh" @click="onReset"></el-button>
                <el-button type="primary" icon="search" @click="onSubmit" native-type="submit">查询</el-button>
                <el-button type="success" @click.native="createModalFunc(1, null)">新增</el-button>
            </el-form-item>
        </el-form>
        <el-table
                v-loading="loading"
                :data="list"
                stripe border style="width: 100%">

            <el-table-column
                label="ID"
                prop="id"
                align="center"
                width="80px">
            </el-table-column>

            <el-table-column label="类型" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.type }}</div>
                </template>
            </el-table-column>
            <el-table-column label="FBA入仓号" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.warehouse_number }}</div>
                </template>
            </el-table-column>

            <el-table-column label="Reference ID" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.reference_id }}</div>
                </template>
            </el-table-column>


            <el-table-column label="编号" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.number }}</div>
                </template>
            </el-table-column>


            <el-table-column label="创建时间" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.created_time }}</div>
                </template>
            </el-table-column>

            <el-table-column label="操作" width="450" align="center" fixed="right">
                <template slot-scope="scope">
<!--                    <el-button type="primary" size="mini" @click.native="openModal(3, scope.row)">产品修改-->
<!--                    </el-button>-->
<!--                    <el-button type="primary" size="mini" @click.native="openModal(2, scope.row)">产品详情-->
<!--                    </el-button>-->
                    <el-button type="primary" size="mini" @click.native="downFile(scope.row.source_path)">源文件下载
                    </el-button>
                    <el-button type="primary" size="mini" @click.native="downFile(scope.row.path)">解析文件下载
                    </el-button>
                    <el-button type="success" size="mini" @click.native="rebuild(scope.row)">重新生成
                    </el-button>
                    <el-button type="danger" size="mini" @click.native="handleDel(scope.$index, scope.row)"
                               :loading="deleteLoading">删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination
                background
                :page-size="query.limit"
                style="float: right;margin-top: 20px; margin-bottom: 22px"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-sizes="[20, 50, 100]"
                layout="total, sizes, prev, pager, next, jumper"
                :current-page="query.page"
                :total="total">
        </el-pagination>

        <add-invoce ref="addInvoiceDom" @close-callback="closeCllback"></add-invoce>

        <createModal :visible="createModalVisible" @close-callback="closeCllback"></createModal>
    </div>
</template>

<script>

    import {
        logistics_invoice_deleted,
        logistics_invoice_index,
        logistics_invoice_reset,
    } from '@/api/advAnalys/advAnalys.js'
    import {downloadFileUrl} from '@/utils/method'
    import AddInvoce from './addInvoce'
    import createModal from './compon/createModal'

    export default {
        components: {AddInvoce, createModal},
        data() {
            return {
                createModalVisible: false,

                pageType: 0,
                query: {
                    type: '',
                    number: '',
                    warehouse_number: '',
                    reference_id: '',
                    page: 1,
                    limit: 20,
                },
                list: [],
                total: 0,
                loading: true,
                deleteLoading: false
            }
        },
        methods: {
            createModalFunc(type, data){
                this.createModalVisible = true
                // this.openModal(type, data)
            },
            closeCllback(refresh) {
                if (refresh == true) {
                    this.getList()
                }
                this.createModalVisible = false
            },
            downFile(path) {
                if (!path) {
                    return this.$message({
                        type: 'error',
                        message: '无法下载！'
                    })
                }
                downloadFileUrl(path)
            },
            rebuild(data) {
                logistics_invoice_reset({id: data.id}).then(response => {
                    this.loading = false
                    this.$message.info(response.data)
                    if (response.success) {
                        this.getList()
                    }else {
                        this.$message.error(response.message)
                    }
                }).catch(() => {
                    this.loading = false
                })
            },
            onReset() {
                this.query = {
                    type: '',
                    number: '',
                    warehouse_number: '',
                    reference_id: '',
                    page: 1,
                    limit: 20,
                    total: 0
                }
                this.getList()
            },
            onSubmit() {
                this.query.page = 1
                this.getList()
            },
            openModal(type, data) {
                let tempData = data
                if (data && data.box_datas) {
                    tempData = JSON.parse(JSON.stringify(tempData))
                    tempData.box_datas = JSON.parse(tempData.box_datas)
                }
                this.$refs.addInvoiceDom.openModal(type, tempData)
            },
            //分页
            handleCurrentChange(val) {
                this.query.page = val
                this.getList()
            },
            handleSizeChange(val) {
                this.query.limit = val
                this.getList()
            },
            getList() {
                this.loading = true
                logistics_invoice_index(this.query)
                    .then(response => {
                        this.loading = false
                        this.list = response.data.list || []
                        this.total = response.data.total || 0
                    })
                    .catch(() => {
                        this.loading = false
                        this.list = []
                        this.total = 0
                    })
            },
            // 删除
            handleDel(index, row) {
                if (row.id) {
                    this.$confirm('确认删除该记录吗?', '提示', {
                        type: 'warning'
                    }).then(() => {
                        this.deleteLoading = true
                        logistics_invoice_deleted({id: row.id})
                            .then(response => {
                                this.deleteLoading = false
                                if (response.code) {
                                    this.$message.error(response.message)
                                    return false
                                }
                                this.$message.success('操作成功')
                                // 刷新数据
                                this.getList()
                            })
                            .catch(() => {
                                this.deleteLoading = false
                            })
                    }).catch(() => {
                        this.$message.info('取消删除')
                    })
                }
            }
        },
        created() {
            this.getList()
        }
    }
</script>

<style type="text/scss" lang="scss">
</style>
